import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  T_ABCDHoldingsSlice,
  T_DigiHoldingsResponseObject,
  T_FetchUserProductStatus_ResponseObject,
  T_FixedDepositResponseObject,
  T_InsuranceHoldingsTransactionObject,
  T_MotorInsuranceDetailsResponseObject,
} from "./Feature_ABCD_Types";

// Initial state with an empty array for userProductStatusData
const initialState: T_ABCDHoldingsSlice = {
  userProductStatusData: {
    customerId: "",
    digigold: "No",
    digisilver: "No",
    pocketInsurance: "No",
    travelInsurance: "No",
    mutualFund: "",
    deposit: "No",
    lastFetchedTime: "",
  },
  digiGoldData: {
    portfolio: "",
    currentValue: "",
    livePrice: "",
    quantity: "",
    balQuantity: "",
    dgTransanctions: [],
  },
  digiSilverData: {
    portfolio: "",
    currentValue: "",
    livePrice: "",
    quantity: "",
    balQuantity: "",
    dgTransanctions: [],
  },
  pocketInsuranceData: [
    {
      coverageOrSumInsured: "",
      policyTerm: "",
      coiNum: "",
      premiumNum: "",
      policyStartDate: "",
      policyEndDate: "",
      productId: "",
    },
  ],
  travelInsuranceData: [
    {
      coverageOrSumInsured: "",
      policyTerm: "",
      coiNum: "",
      premiumNum: "",
      policyStartDate: "",
      policyEndDate: "",
      productId: "",
    },
  ],
  fixedDepositData: {
    currentValue: "",
    totalReturns: "",
    totalInvested: "",
    numOfFDs: "",
  },
  motorInsuranceData: [
    {
      vehicleNumber: "",
      vehicleCategory: "",
      vehicleMMV: "",
      proposalId: "",
      calculatedIdv: "",
      policyNumber: "",
      policyStartDate: "",
      policyExpiryDate: "",
      insurerName: "",
      planId: "",
      planName: "",
      productType: "",
    },
  ],
};

export const ABCDHoldingsSlice = createSlice({
  name: "ABCDHoldingsSlice",
  initialState,
  reducers: {
    setUserProductStatusDetails: (
      state,
      action: PayloadAction<T_FetchUserProductStatus_ResponseObject>
    ) => {
      return { ...state, userProductStatusData: action.payload };
    },
    setDigiGoldHoldingsData: (
      state,
      action: PayloadAction<T_DigiHoldingsResponseObject>
    ) => {
      return { ...state, digiGoldData: action.payload };
    },
    setDigiSilverHoldingsData: (
      state,
      action: PayloadAction<T_DigiHoldingsResponseObject>
    ) => {
      return { ...state, digiSilverData: action.payload };
    },
    setPocketInsuranceHoldingsData: (
      state,
      action: PayloadAction<T_InsuranceHoldingsTransactionObject[]>
    ) => {
      return { ...state, pocketInsuranceData: action.payload };
    },
    setTravelInsuranceHoldingsData: (
      state,
      action: PayloadAction<T_InsuranceHoldingsTransactionObject[]>
    ) => {
      return { ...state, travelInsuranceData: action.payload };
    },
    setFixedDepositHoldingsData: (
      state,
      action: PayloadAction<T_FixedDepositResponseObject>
    ) => {
      return { ...state, fixedDepositData: action.payload };
    },
    setMotorInsuranceHoldingsData: (
      state,
      action: PayloadAction<T_MotorInsuranceDetailsResponseObject[]>
    ) => {
      return { ...state, motorInsuranceData: action.payload };
    },
  },
});

export const ABCDHoldingsReducer = ABCDHoldingsSlice.reducer;
export const ABCDHoldingsSliceKey = ABCDHoldingsSlice.reducerPath;
export const {
  setUserProductStatusDetails,
  setDigiGoldHoldingsData,
  setDigiSilverHoldingsData,
  setPocketInsuranceHoldingsData,
  setTravelInsuranceHoldingsData,
  setFixedDepositHoldingsData,
  setMotorInsuranceHoldingsData,
} = ABCDHoldingsSlice.actions;
